import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home.vue';
import Login from '@/components/Login.vue';
import Invoice from '@/components/invoice/Invoice.vue';
import InvoiceList from '@/components/invoice/InvoiceList.vue';
import Plans from '@/components/sales/Plans.vue';
import Sales from '@/components/sales/Sales.vue';
import Arrears from '@/components/sales/Arrears.vue';
import PaymentList from '@/components/payments/PaymentList.vue';
import Payment from '@/components/payments/Payment.vue';
import BonusList from '@/components/bonus/BonusList.vue';
import TaskList from '@/components/task/TaskList.vue';
import Balance from '@/components/balance/Balance.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/invoices/:countryID/:doc_id',
            name: 'invoiceItem',
            component: Invoice,
        },
        {
            path: '/invoices',
            name: 'invoices',
            meta: {
                title: 'Docs',
            },
            component: InvoiceList,
        },
        {
            path: '/tasks',
            name: 'tasks',
            meta: {
                title: 'Tasks',
            },
            component: TaskList,
        },
        {
            path: '/plans',
            name: 'plans',
            component: Plans,
        },
        {
            path: '/sales',
            name: 'sales',
            component: Sales,
        },
        {
            path: '/arrears',
            name: 'arrears',
            component: Arrears,
        },
        {
            path: '/payments',
            name: 'payments',
            component: PaymentList,
        },
        {
            path: '/payment/:id',
            name: 'payment',
            component: Payment,
        },
        {
            path: '/bonuses',
            name: 'bonuses',
            component: BonusList,
        },
        {
            path: '/balance',
            name: 'balance',
            component: Balance,
        },
    ],
});
